export default __webpack_public_path__ + "static/media/art_marketplace.63a3eeef.png";